import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  Button,
  Table,
} from "react-bootstrap";

import {
  FaSyncAlt,
} from "react-icons/fa";

import {
  getViajes,
  anularViaje,
  getViajeById,
} from "../helpers/rutaViajes";

import ModalFormViaje from "./ModalFormViaje";

import {
  generarPDFviajeConDetalles,
} from "../helpers/pdfViajes";

import "../css/tablecomandas.css";
import "../css/rendiciones.css";

const REGISTROS_POR_PAGINA = 10;
const PAGINAS_VISIBLES = 4;

const TableViajes = () => {
  const [
    viajes,
    setViajes,
  ] = useState({
    data: {
      viajes: [],
    },
    loading: true,
  });

  const [
    viaje,
    setViaje,
  ] = useState({});

  const [
    show,
    setShow,
  ] = useState(false);

  const [
    busqueda,
    setBusqueda,
  ] = useState("");

  const [
    pagina,
    setPagina,
  ] = useState(1);

  /* ======================================================
     CARGA
  ====================================================== */

  useEffect(() => {
    consultaViajes();
  }, []);

  const consultaViajes = () => {
    getViajes().then(
      (datos) => {
        if (
          Array.isArray(datos)
        ) {
          setViajes({
            data: {
              viajes: datos,
            },
            loading: false,
          });
        } else {
          console.error(
            "Error al obtener viajes:",
            datos
          );

          setViajes({
            data: {
              viajes: [],
            },
            loading: false,
          });
        }
      }
    );
  };

  /* ======================================================
     ACCIONES EXISTENTES
  ====================================================== */

  const anularViajeHandler = async (id) => {
    const confirmar = window.confirm(
      "¿Está seguro que desea anular esta rendición?"
    );

    if (!confirmar) return;

    try {
      const resp = await anularViaje(id);

      if (!resp || resp.ok === false) {
        const error = resp?.error;

        const mensaje =
          typeof error === "string"
            ? error
            : error?.mensaje ||
              error?.message ||
              error?.err?.message ||
              resp?.mensaje ||
              resp?.message ||
              JSON.stringify(error || resp) ||
              "No se pudo anular la rendición.";

        window.alert(mensaje);
        console.error("Error al anular rendición:", resp);
        return;
      }

      consultaViajes();
    } catch (error) {
      window.alert(
        error?.message || "Error al anular la rendición."
      );
    }
  };

  const modificaViaje =
    async (id) => {
      const resp =
        await getViajeById(
          id
        );

      if (resp.ok) {
        setViaje(
          resp.viaje
        );

        setShow(true);
      } else {
        console.error(
          "❌ Error al obtener viaje:",
          resp.error ||
            "Respuesta vacía"
        );
      }
    };

  const handleClose = () => {
    setShow(false);

    consultaViajes();
  };

  /* ======================================================
     CÁLCULO ORIGINAL
  ====================================================== */

  const calcularResumen = (
    v
  ) => {
    const kmTableros =
      (
        v.combustible ||
        []
      )
        .map(
          (c) =>
            Number(
              c.kmTablero
            )
        )
        .filter(
          (km) =>
            !isNaN(km)
        );

    const totalKm =
      kmTableros.length >=
      2
        ? Math.max(
            ...kmTableros
          ) -
          Math.min(
            ...kmTableros
          )
        : 0;

    const tarifa =
      Number(
        v.tarifaPorKm ||
          130
      );

    const totalLitros =
      (
        v.combustible ||
        []
      ).reduce(
        (sum, c) =>
          sum +
          Number(
            c.litros
          ),
        0
      );

    const totalCombustible =
      (
        v.combustible ||
        []
      ).reduce(
        (sum, c) =>
          sum +
          Number(
            c.monto
          ),
        0
      );

    const totalViaticos =
      (
        v.viaticos ||
        []
      ).reduce(
        (sum, item) =>
          sum +
          Number(
            item.monto
          ),
        0
      );

    const totalAdelantos =
      (
        v.adelantos ||
        []
      ).reduce(
        (sum, a) =>
          sum +
          Number(
            a.monto
          ),
        0
      );

    const totalGastos =
      (
        v.gastos ||
        []
      ).reduce(
        (sum, g) =>
          sum +
          Number(
            g.monto
          ),
        0
      );

    const promedioConsumo =
      totalLitros > 0
        ? (
            totalKm /
            totalLitros
          ).toFixed(2)
        : "-";

    const liquidacionFinal1 =
      totalKm *
        tarifa +
      totalViaticos;

    const liquidacionFinal2 =
      totalAdelantos -
      totalGastos;

    const liquidacionFinal =
      liquidacionFinal1 -
      liquidacionFinal2;

    return {
      totalKm,
      totalLitros,
      promedioConsumo,
      totalCombustible,
      totalViaticos,
      totalAdelantos,
      totalGastos,
      liquidacionFinal,
      valorKm:
        tarifa,
      valorViaje:
        totalKm *
        tarifa,
    };
  };

  /* ======================================================
     BÚSQUEDA
  ====================================================== */

  const viajesFiltrados =
    useMemo(() => {
      const lista =
        viajes.data
          .viajes ||
        [];

      const texto =
        busqueda
          .trim()
          .toLowerCase();

      if (!texto) {
        return lista;
      }

      return lista.filter(
        (v) => {
          const contenido =
            [
              v.nroViaje,
              v.choferId
                ?.nombre,
              v.camionId
                ?.camion,
              v.camionId
                ?.patente,
              v.estado,
            ]
              .filter(
                (x) =>
                  x !==
                    null &&
                  x !==
                    undefined
              )
              .join(" ")
              .toLowerCase();

          return contenido.includes(
            texto
          );
        }
      );
    }, [
      viajes.data.viajes,
      busqueda,
    ]);

  useEffect(() => {
    setPagina(1);
  }, [busqueda]);

  /* ======================================================
     PAGINACIÓN
  ====================================================== */

  const totalPaginas =
    Math.max(
      1,
      Math.ceil(
        viajesFiltrados.length /
          REGISTROS_POR_PAGINA
      )
    );

  useEffect(() => {
    if (
      pagina >
      totalPaginas
    ) {
      setPagina(
        totalPaginas
      );
    }
  }, [
    pagina,
    totalPaginas,
  ]);

  const inicio =
    (
      pagina -
      1
    ) *
    REGISTROS_POR_PAGINA;

  const fin =
    inicio +
    REGISTROS_POR_PAGINA;

  const viajesPagina =
    viajesFiltrados.slice(
      inicio,
      fin
    );

  const paginas =
    useMemo(() => {
      let primera =
        pagina - 1;

      if (
        primera < 1
      ) {
        primera = 1;
      }

      let ultima =
        primera +
        PAGINAS_VISIBLES -
        1;

      if (
        ultima >
        totalPaginas
      ) {
        ultima =
          totalPaginas;

        primera =
          Math.max(
            1,
            ultima -
              PAGINAS_VISIBLES +
              1
          );
      }

      const resultado =
        [];

      for (
        let i = primera;
        i <= ultima;
        i++
      ) {
        resultado.push(i);
      }

      return resultado;
    }, [
      pagina,
      totalPaginas,
    ]);

  /* ======================================================
     RENDER
  ====================================================== */

  return (
    <div className="ren2-card">

      {!viajes.loading && (
        <>
          {/* TOOLBAR */}

          <div className="ren2-toolbar">
            <div className="ren2-toolbar-title">
              <h4>
                Rendiciones registradas
              </h4>

              <span>
                {
                  viajesFiltrados.length
                }{" "}
                registros
              </span>
            </div>

            <div className="ren2-toolbar-actions">
              <div className="ren2-search">
                <label>
                  Buscar
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Viaje, chofer, camión..."
                  value={
                    busqueda
                  }
                  onChange={(
                    e
                  ) =>
                    setBusqueda(
                      e.target
                        .value
                    )
                  }
                />

                {busqueda && (
                  <button
                    type="button"
                    className="ren2-clear"
                    onClick={() =>
                      setBusqueda(
                        ""
                      )
                    }
                  >
                    ×
                  </button>
                )}
              </div>

              <Button
                variant="outline-secondary"
                size="sm"
                className="ren2-refresh"
                onClick={
                  consultaViajes
                }
                title="Actualizar"
              >
                <FaSyncAlt />
              </Button>
            </div>
          </div>

          {/* INFO */}

          <div className="ren2-info">
            <span>
              Mostrando{" "}
              <strong>
                {viajesFiltrados.length
                  ? inicio +
                    1
                  : 0}
              </strong>{" "}
              a{" "}
              <strong>
                {Math.min(
                  fin,
                  viajesFiltrados.length
                )}
              </strong>{" "}
              de{" "}
              <strong>
                {
                  viajesFiltrados.length
                }
              </strong>
            </span>

            <span>
              Página{" "}
              <strong>
                {pagina}
              </strong>{" "}
              de{" "}
              <strong>
                {
                  totalPaginas
                }
              </strong>
            </span>
          </div>

          {/* TABLA */}

          <div className="ren2-table-scroll">
            <Table
              striped
              bordered
              hover
              className="table-container ren2-table"
            >
              <thead>
                <tr>
                  <th className="ren2-actions-col">
                    Acciones
                  </th>

                  <th>
                    Nro Viaje
                  </th>

                  <th>
                    Chofer
                  </th>

                  <th>
                    Camión
                  </th>

                  <th>
                    Total KM
                  </th>

                  <th>KM Ini</th>
                  <th>KM Fin</th>

                  <th>
                    Valor KM
                  </th>

                  <th>
                    Valor Viaje
                  </th>

                  <th>
                    Combustible
                  </th>

                  <th>
                    Promedio
                  </th>

                  <th>
                    Viáticos
                  </th>

                  <th>
                    Adelantos
                  </th>

                  <th>
                    Gastos
                  </th>

                  <th>
                    Total a Cobrar
                  </th>
                </tr>
              </thead>

              <tbody>
                {viajesPagina.length ===
                0 ? (
                  <tr>
                    <td
                      colSpan={15}
                      className="ren2-empty"
                    >
                      No hay rendiciones para mostrar.
                    </td>
                  </tr>
                ) : (
                  viajesPagina.map(
                    (v) => {
                      const resumen =
                        calcularResumen(
                          v
                        );

                      return (
                        <tr
                          key={
                            v._id
                          }
                        >
                          <td className="ren2-row-actions">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() =>
                                modificaViaje(
                                  v._id
                                )
                              }
                              title="Editar"
                            >
                              <i className="fa fa-pencil" />
                            </button>

                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                anularViajeHandler(
                                  v._id
                                )
                              }
                              title="Anular"
                            >
                              <i className="fa fa-trash" />
                            </button>

                            <button
                              className="btn btn-secondary btn-sm"
                              onClick={() =>
                                generarPDFviajeConDetalles(
                                  v
                                )
                              }
                              title="Generar PDF completo"
                            >
                              <i className="fa fa-file-pdf-o" />
                            </button>
                          </td>

                          <td>
                            {
                              v.nroViaje
                            }
                          </td>

                          <td>
                            {v.choferId
                              ?.nombre ||
                              "-"}
                          </td>

                          <td>
                            {v.camionId
                              ? `${v.camionId.camion || ""} (${v.camionId.patente || ""})`
                              : "-"}
                          </td>

                          <td className="ren2-number">
                            {
                              resumen.totalKm
                            }
                          </td>

                          <td className="ren2-number" style={{ color: "red" }}>
                            {v.kmInicioTablero == null
                              ? "-"
                              : Number(v.kmInicioTablero).toLocaleString("es-AR")}
                          </td>

                          <td className="ren2-number" style={{ color: "red" }}>
                            {v.kmFinTablero == null
                              ? "-"
                              : Number(v.kmFinTablero).toLocaleString("es-AR")}
                          </td>

                          <td className="ren2-money">
                            {resumen.valorKm.toLocaleString(
                              "es-AR",
                              {
                                style:
                                  "currency",
                                currency:
                                  "ARS",
                              }
                            )}
                          </td>

                          <td className="ren2-money">
                            {resumen.valorViaje.toLocaleString(
                              "es-AR",
                              {
                                style:
                                  "currency",
                                currency:
                                  "ARS",
                              }
                            )}
                          </td>

                          <td className="ren2-money">
                            {resumen.totalCombustible.toLocaleString(
                              "es-AR",
                              {
                                style:
                                  "currency",
                                currency:
                                  "ARS",
                              }
                            )}
                          </td>

                          <td className="ren2-number">
                            {
                              resumen.promedioConsumo
                            }
                          </td>

                          <td className="ren2-money">
                            {resumen.totalViaticos.toLocaleString(
                              "es-AR",
                              {
                                style:
                                  "currency",
                                currency:
                                  "ARS",
                              }
                            )}
                          </td>

                          <td className="ren2-money">
                            {resumen.totalAdelantos.toLocaleString(
                              "es-AR",
                              {
                                style:
                                  "currency",
                                currency:
                                  "ARS",
                              }
                            )}
                          </td>

                          <td className="ren2-money">
                            {resumen.totalGastos.toLocaleString(
                              "es-AR",
                              {
                                style:
                                  "currency",
                                currency:
                                  "ARS",
                              }
                            )}
                          </td>

                          <td className="ren2-money ren2-total">
                            {resumen.liquidacionFinal.toLocaleString(
                              "es-AR",
                              {
                                style:
                                  "currency",
                                currency:
                                  "ARS",
                              }
                            )}
                          </td>
                        </tr>
                      );
                    }
                  )
                )}
              </tbody>
            </Table>
          </div>

          {/* PAGINACIÓN */}

          <div className="ren2-pagination">
            <span className="ren2-page-size">
              10 rendiciones por página
            </span>

            <div className="ren2-pagination-buttons">
              <button
                type="button"
                disabled={
                  pagina === 1
                }
                onClick={() =>
                  setPagina(1)
                }
              >
                «
              </button>

              <button
                type="button"
                disabled={
                  pagina === 1
                }
                onClick={() =>
                  setPagina(
                    pagina - 1
                  )
                }
              >
                ‹
              </button>

              {paginas.map(
                (numero) => (
                  <button
                    type="button"
                    key={numero}
                    className={
                      numero ===
                      pagina
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      setPagina(
                        numero
                      )
                    }
                  >
                    {numero}
                  </button>
                )
              )}

              <button
                type="button"
                disabled={
                  pagina ===
                  totalPaginas
                }
                onClick={() =>
                  setPagina(
                    pagina + 1
                  )
                }
              >
                ›
              </button>

              <button
                type="button"
                disabled={
                  pagina ===
                  totalPaginas
                }
                onClick={() =>
                  setPagina(
                    totalPaginas
                  )
                }
              >
                »
              </button>
            </div>
          </div>

          <ModalFormViaje
            show={show}
            handleClose={
              handleClose
            }
            viaje={viaje}
          />
        </>
      )}
    </div>
  );
};

export default TableViajes;